export const CustomQuestionsAnswerType = {
  TEXT: 'Text',
  BOOL: 'Bool',
  INTEGER: 'Integer',
  DOUBLE: 'Double',
};
